import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { getHandlingUnitTypesForDropdown } from "@/Data/getHandlingUnitTypesForDropdown";

import type { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";

interface HandlingUnityTypeControlProps {
  usePluralForm: boolean;
  onChange: (value: HandlingUnitType) => void;
  value: HandlingUnitType | undefined;
  placeholder?: string | undefined;
  errorMessage?: ErrorMessageType | undefined;
  forceValidation?: boolean | undefined;
}

const LineItemsHandlingUnitTypeInput: React.FC<
  HandlingUnityTypeControlProps
> = (props: HandlingUnityTypeControlProps) => {
  const options = getHandlingUnitTypesForDropdown(props.usePluralForm);

  const emptyState = props.usePluralForm
    ? "Select Handling Units"
    : "Select Handling Unit";

  return (
    <ShowFormErrors show={Boolean(props.forceValidation)}>
      <FormItem label={props.placeholder} error={props.errorMessage} fillWidth>
        <Dropdown
          options={options}
          value={props.value}
          onChange={(v) => props.onChange(v as HandlingUnitType)}
          placeholder={emptyState}
          width="full"
          data-testid="handlingUnitTypeControl"
        />
      </FormItem>
    </ShowFormErrors>
  );
};
export default LineItemsHandlingUnitTypeInput;
